// ShopPageBanner.jsx
import React from 'react';
import FloatingHero from '../../../../components/user/general/banner/Banner.js';
import hero2Img from '../../../../assets/images/home/hero2.jpg'; 

const ShopPageBanner = ({ shop }) => {
  // shop object should contain: name, description, bannerImage
  return (
    <>
      <FloatingHero
        title="Explore Shops"
        subtitle="Explore all our trusted shops and find the perfect equipment for your needs"
        backgroundImage={hero2Img}
        darkOverlay={0.65}
      />
    </>
  );
};

export default ShopPageBanner;
